import { useReCaptcha, VueReCaptcha } from "vue-recaptcha-v3";

export async function useVueRecaptcha(): Promise<IOurRecaptchaComposition> {
  const { vueApp } = useNuxtApp();

  const config = useRuntimeConfig();

  vueApp.use(VueReCaptcha, {
    siteKey: config.public.RECAPTCHA_SITE_KEY as string,
    loaderOptions: { autoHideBadge: false },
  });

  const recaptcha = useReCaptcha();

  if (recaptcha === undefined) {
    throw new Error("Recaptcha is undefined");
  }

  await recaptcha.recaptchaLoaded();

  return {
    execute: async (action) => {
      return await recaptcha.executeRecaptcha(action);
    },
    show: () => {
      recaptcha.instance.value?.showBadge();
    },
    hide: () => {
      recaptcha.instance.value?.hideBadge();
    },
  };
}

export interface IOurRecaptchaComposition {
  execute: (action: string) => Promise<string>;
  show: () => void;
  hide: () => void;
}
